export const type = 'showModalLoading';

const showModalLoading = (accion) => ({
    type,
    payload: new Date(),
    accion:accion,
    
});

export default showModalLoading;